/* Imports */
import { Scene, SceneText } from "./scene.js";
import Defaults from "./defaults.js";
import { Globals } from "./globals.js";
import { AudioManager } from "./audio.js";
import defaults from "./defaults.js";
import * as Utils from "./utils.js";
import * as constants from './constants.js';
import { WordList } from "./wordlist.js";

class SlowGlass {
    static nextGroupsRun = 0;
    static nextSpriteUpdate = 0;
    static sg_id = "body";
    static clean = true;

    constructor() {
    }
/**************************************************************************************************

   ########  ########    ###    ########  ######## ######## ##     ## ######## 
   ##     ## ##         ## ##   ##     ##    ##    ##        ##   ##     ##    
   ##     ## ##        ##   ##  ##     ##    ##    ##         ## ##      ##    
   ########  ######   ##     ## ##     ##    ##    ######      ###       ##    
   ##   ##   ##       ######### ##     ##    ##    ##         ## ##      ##    
   ##    ##  ##       ##     ## ##     ##    ##    ##        ##   ##     ##    
   ##     ## ######## ##     ## ########     ##    ######## ##     ##    ##    

**************************************************************************************************/

    readFromText(text, include = false, URLFolder = "") {
        const script = text.split(/\r?\n/);
        const count = script.length;
        const top = new SceneText(constants.MAIN_NAME, URLFolder);
        let main = top;
        let holding = null;
        let inComment = false;
        let inDescription = false;
        for(let i = 0; i < script.length; i++ ) {
            let lineCount = i + 1;
            let currentLine = script[i].trim();
            while (currentLine.endsWith('\\')) {
                // take off the backslash
                currentLine = currentLine.slice(0,-1);
                i += 1;
                if (i < script.length) {
                    // add in the new line
                    currentLine += " " + script[i].trim();
                }
            }
            if (inDescription) {
                if (currentLine.match(/^end ?notes?/)) {
                    inDescription = false;
                }
                continue;
            }
            // handle 'C' style comments
            // remove all within single line
            currentLine = currentLine.replace(/\/\*[\s\S]*?\*\//g, '');
            // Now deal with multi-line comments
            if (inComment) {
                if (currentLine.match(/\*\//)) {
                    let endPos = currentLine.search(/\*\//);
                    // discard up to comment end
                    currentLine = currentLine.substr(endPos + 1);
                    inComment = false;
                } else {
                    continue; // discard whole line
                }
            }
            if (currentLine.match(/\/\*/)) {
                let startPos = currentLine.search(/\/\*/);
                // discard from the start comment onwards
                currentLine = currentLine.substr(0, startPos);
                inComment = true;
            }
            /* discard single line comments, empty lines etc.  */
            currentLine = currentLine.replace(/[^:]\/\/.*$/,'');
            if (currentLine.length < 2 || currentLine.startsWith('#')) { // we have no short commands etc.
                continue;
            }
            if (!currentLine.match(/\w+/)) { // and all commands are text
                continue;
            }
            // ignore any punctuation used to show indenting
            currentLine = currentLine.replace(/^[^a-zA-Z0-9"\$]+/,"");
            const wordList = new WordList(currentLine, lineCount);
            // ignore and as the first word (syntactic sugar)
            wordList.testWord("and");
            // Handle scene management commands
            const command = wordList.getWord();
            if (command == "notes") {
                inDescription = true;
                continue;
            }
            const argument = wordList.getWord();
            // Look for a new scene
            if (command == 'scene') {
                if (argument == null) {
                    Globals.log.error(`expected scene name on line ${lineCount}`);
                } else if (!argument.match(/[a-zA-z]/)) {
                    Globals.log.error(`Scene name must contain at least one letter ${lineCount}`);
                } else {
                    if (holding != null) {
                        Globals.sceneTexts.push(holding);
                    }
                    holding = new SceneText(argument, URLFolder);
                    if (argument == constants.MAIN_NAME) {
                        main = holding;
                    }
                    // Any other content on the line is assumed to be tags
                    holding.tags.addTag(wordList.getTags());
                }
            // look for an explicit scene end
            } else if (command == 'end') {
                if (argument == 'file') {
                    // end processing (ignore rest of file)
                    break;
                } else if (argument == 'scene') {
                    if (holding != null) {
                        Globals.sceneTexts.push(holding);
                        holding = null;
                    } else {
                        Globals.log.error(`no current scene at line ${lineCount}`);
                    }
                }
                // alternative forms of the above
            } else if (command == "endfile") {
                break;
            } else if (command == "endscene") {
                if (holding != null) {
                    Globals.sceneTexts.push(holding);
                    holding = null;
                } else {
                    Globals.log.error(`no current scene at line ${lineCount}`);
                }
            } else if (command == "stage" || command == "display" || command == "canvas") {
                if (include) {
                    Globals.log.error('Stage Directions in include will be ignored!');
                    continue;
                }
                switch (argument) {
                    case 'width': {
                            let displayWidth = wordList.getInt();
                            if (displayWidth < 50 || displayWidth > 5000) {
                                Globals.log.error("silly display width");
                                displayWidth = defaults.DISPLAY_WIDTH;
                            }
                            Globals.displayWidth = displayWidth;
                        }
                        break;
                    case 'height':{
                            let displayHeight = wordList.getInt();
                            if (displayHeight < 50 || displayHeight > 5000) {
                                Globals.log.error("silly display height");
                                displayHeight = defaults.DISPLAY_HEIGHT;
                            }
                            Globals.displayHeight = displayHeight;
                        }
                        break;
                    case 'size': {
                            let displayWidth = wordList.getInt();
                            if (displayWidth < 50 || displayWidth > 5000) {
                                Globals.log.error("silly display width");
                                displayWidth = defaults.DISPLAY_WIDTH;
                            }
                            Globals.displayWidth = displayWidth;
                            let displayHeight = wordList.getInt();
                            if (displayHeight < 50 || displayHeight > 5000) {
                                Globals.log.error("silly display height");
                                displayHeight = defaults.DISPLAY_HEIGHT;
                            }
                            Globals.displayHeight = displayHeight;
                        }
                        break;
                    case "colour":
                    case "color":
                    case "background":
                        Globals.displayColour = wordList.getWord();
                        break;
                    case "fullscreen":
                        Globals.log.report("Full screen not supported yet");
                        break;
                    default:
                        Globals.log.error(`Unknown display option ${argument}`);
                        break;
                } 
            } else if (command == 'script') {
                if (include) {
                    Globals.log.error('Stage Directions in include will be ignored!');
                    continue;
                }
                if (argument == 'width') {
                    let scriptWidth = wordList.getInt();
                    if (scriptWidth < 50 || scriptWidth > 5000) {
                        Globals.log.error("silly script width");
                        scriptWidth = defaults.DISPLAY_WIDTH;
                    }
                    Globals.scriptWidth = scriptWidth;
                } else if (argument == 'height') {
                    let scriptHeight = wordList.getInt();
                    if (scriptHeight < 50 || scriptHeight > 5000) {
                        Globals.log.error("silly script height");
                        scriptHeight = defaults.DISPLAY_HEIGHT;
                    }
                    Globals.scriptHeight = scriptHeight;
                } else if (argument == "scale") {
                    switch (wordList.getWord()) {
                        case "fit":
                            Globals.scriptScaleType = constants.SCALE_FIT;
                            break;
                        case "stretch":
                            Globals.scriptScaleType = constants.SCALE_STRETCH;
                            break;
                        case "none":
                        default:
                            Globals.scriptScaleType = constants.SCALE_STRETCH;
                            break;
                    }
                }
            } else if (command == "option") {
                switch(argument) {
                    case "lat":
                    case "latitude":
                        Globals.location.setLat(wordList.getWord());
                        break;
                    case "lon":
                    case "long":
                    case "longitude":
                        Globals.location.setLon(wordList.getWord());
                        break;
                    case "evaluator":
                        const argument2 = wordList.getWord();
                        if (argument2 == "basic" && Globals.basicEvaluator) {
                            Globals.evaluator = argument2;
                        } else if (argument2 == "advanced" && Globals.advancedEvaluator) {
                            Globals.evaluator = argument2;
                        } else {
                            Globals.log.error("Unknown evaluator - " + argument2);
                        }
                        break;
                    default:
                        Globals.log.error("Unknown option - " + argument);
                        break;
                }
            } else {
                // must be an action, trigger or condition
                const line = new Utils.Line(lineCount, currentLine);
                if (holding == null) {
                    top.content.push(line);
                } else {
                    holding.content.push(line);
                }
            }
        }
        // add the final scene if unterminated
        if (holding != null) {
            Globals.sceneTexts.push(holding);
        }
        if (include) {
            // scenes have already been added, we may have some top level commands
            top.name = "_INCLUDE_";
            top.state = constants.SCENE_RUNNING;
            // Globals.scenes.push(top);
            // merge it with the existing top scene
            const mainScene = Scene.find(constants.MAIN_NAME, false);
            mainScene.merge(top);
            // top can now be discarded
        } else {
            if (top.content.length < 1 && main == top) {
                Globals.log.error('No main scene, nothing will happen!');
                return false;
            } else {
                // calculate overall scaling
                if (Globals.scriptWidth == 0) { // was never set
                    Globals.scriptWidth = Globals.displayWidth;
                }
                if (Globals.scriptHeight == 0) { // was never set
                    Globals.scriptHeight = Globals.displayHeight;
                }
                switch (Globals.scriptScaleType) {
                    case constants.SCALE_STRETCH:
                        Globals.scriptScaleX = Globals.displayWidth / Globals.scriptWidth;
                        Globals.scriptScaleY = Globals.displayHeight / Globals.scriptHeight;
                        break;
                    case constants.SCALE_FIT:
                        // todo
                    case constants.SCALE_NONE:
                    default:
                        break;
                }
                // Add an empty action group to the top level for interactive actions
                if (top.content.length > 0) {
                    Globals.sceneTexts.push(top);
                }
                const scene = new Scene(main, constants.MAIN_NAME);
                scene.interactive_index = scene.actionGroups.length;
                Scene.manageLifecycle(scene, constants.SCENE_MAKE_RUNNABLE);
                scene.actionGroups.push(new Utils.ActionGroup());
                // If there is a data scene, auto run that as well
                const dataSceneText = SceneText.find(constants.DATA_NAME, false);
                if (dataSceneText) {
                    const dataScene = new Scene(dataSceneText, constants.DATA_NAME);
                    Scene.manageLifecycle(dataScene, constants.SCENE_MAKE_RUNNABLE);
                    Globals.dataScene = dataScene;
                }
            }
        }
        return true;
    }

/**************************************************************************************************

   ########  ##     ## ##    ## 
   ##     ## ##     ## ###   ## 
   ##     ## ##     ## ####  ## 
   ########  ##     ## ## ## ## 
   ##   ##   ##     ## ##  #### 
   ##    ##  ##     ## ##   ### 
   ##     ##  #######  ##    ## 

**************************************************************************************************/

    async run() {
        this.clean = false;
        Globals.startTime = Date.now();
        // Initialise renderer (Pixi v8 requirement)
        await Globals.app.init({
            // resizeTo: window,
            background: Globals.displayColour,
            width: Globals.displayWidth,
            height: Globals.displayHeight,
        });

        // Make canvas focusable
        Globals.app.canvas.tabIndex = 1000;
        Globals.app.canvas.focus();
        // Add canvas to page
        Globals.app.canvas.onkeydown = function(e) {Globals.event("onkeydown", e.key);};
        Globals.app.canvas.onkeyup = function(e) {Globals.event("onkeyup", e.key);};
        const pixi = document.getElementById(SlowGlass.sg_id);
        pixi.appendChild(Globals.app.canvas);

        // Root container for scene
        Globals.root = new PIXI.Container();
        Globals.root.sortableChildren = true;
        Globals.app.stage.addChild(Globals.root);

        // Run setup for the main scene
        this.update();

        // Main loop
        Globals.app.ticker.add(this.update);

        // Keep sprite centred when window resizes
        // window.addEventListener("resize", () => {
        // });
    }

/**************************************************************************************************

   ##     ## ########  ########     ###    ######## ######## 
   ##     ## ##     ## ##     ##   ## ##      ##    ##       
   ##     ## ##     ## ##     ##  ##   ##     ##    ##       
   ##     ## ########  ##     ## ##     ##    ##    ######   
   ##     ## ##        ##     ## #########    ##    ##       
   ##     ## ##        ##     ## ##     ##    ##    ##       
    #######  ##        ########  ##     ##    ##    ######## 

**************************************************************************************************/

    updateSprite(sprite, sceneName, now) {
        // If sprite is a group, update all its children
        if (sprite.type == constants.SPRITE_GROUP) {
            for (let i = 0; i < sprite.children.length; i++) {
                const childSprite = sprite.children[i];
                if (childSprite.type == constants.SPRITE_GROUP) {
                    this.updateSprite(childSprite, sceneName, now);
                } else {
                    childSprite.update(sceneName, now);
                }
            }
        }
        // Now update yourself if top level
        if (!sprite.sgParent) {
            sprite.update(sceneName, now);
        }
    }


    update(ticker) {
        if (Globals.breakpointCondition == "update") {
            Globals.breakpointCondition = false;
            debugger;
        }
        // Action granularity is only 1 second, so only update every 0.5 seconds
        // (to ensure we catch triggers that are accurate to 1 second, e.g. "at"
        // Could adjust this if needed in defaults
        let millis = Date.now();
        let nextRun = Defaults.TRIGGER_RATE;
        let deletedScenes = [];
        if (SlowGlass.nextGroupsRun < millis) {
            // why is this here?
            // if (Globals.app.screen.width != Globals.displayWidth) {
            //     Globals.app.screen.width = Globals.displayWidth;
            // }
            // if (Globals.app.screen.height != Globals.displayHeight) {
            //     Globals.app.screen.height = Globals.displayHeight;
            // }
            for ( let i = 0; i < Globals.scenes.length; i++ ) {
                let current = Globals.scenes[i];
                current.updateState = true; // let's assume we need to move on
                if (current.state != constants.SCENE_PAUSED) {
                    // we are only interested in running scenes 
                    // Found an active scene, now go through each action group
                    for ( let j = 0; j < current.actionGroups.length; j++ ) {
                        let doRun = false;
                        let firstAction = 0;
                        const actionGroup = current.actionGroups[j];
                        // Is this a suspended group that can be restarted?
                        if (actionGroup.suspended) {
                            // What was the reason for the suspension?
                            switch(actionGroup.waitType) {
                                case "pause":
                                    doRun = millis > actionGroup.waitClause;
                                    break;
                                case 'call':
                                    doRun = actionGroup.waitClause.allActionsFinished();
                                    break;
                                case "then":
                                    doRun = actionGroup.allPriorFinished();
                                    break;
                                case "until":
                                case "while":
                                    const expanded = current.varList.expandVars(actionGroup.waitClause);
                                    const evaluated = Utils.evaluate(expanded);
                                    const conditionList = new WordList(evaluated);
                                    doRun = Utils.logical(conditionList);
                                    if (actionGroup.waitType == "while") {
                                        doRun = !doRun;
                                    }
                                    break;
                                case "fileLoading":
                                    if (!actionGroup.waitClause.loading) {
                                        doRun = true;
                                    }
                                    break;
                                case "newScene":
                                    // we are just waiting for a new scene to start
                                    if (actionGroup.waitClause.state == constants.SCENE_RUNNING) {
                                        doRun = true;
                                    }
                                    break;
                                case "placeGroup":
                                    // A group has been placed, wait for all sprites to update
                                    if (actionGroup.waitClause.loaded) {
                                        doRun = true;
                                    }
                                    break;
                            }
                            if (doRun) {
                                firstAction = actionGroup.resume();
                            } else {
                                continue; // still suspended, go on to next group
                            }
                        }  else { // not suspended, test the triggers
                            let triggers = current.actionGroups[j].triggers;
                            for ( let k = 0; k < triggers.length; k++) {
                                // this implements the any/all condition. It is set by looking
                                // at each trigger in turn. If the when condition is "any"
                                // we immediately break out of the loop and run actions
                                // If when is "all" we break out of the loop as soon as a
                                // trigger fails. Hence the only way to get out of the loop
                                // with doRun set to true is for all the triggers to succeed
                                // check each trigger, if ANY is valid then execute actions
                                if (triggers[k].fired(millis)) {
                                    current.varList.trigger = triggers[k].constructor.name;
                                    doRun = true;
                                    if (actionGroup.anyTrigger) {
                                        break;
                                    }
                                } else {
                                    doRun = false;
                                    if (!actionGroup.anyTrigger) {
                                        break;
                                    }
                                }
                            }
                        }
                        if (doRun) {
                            current.runGroup(j, millis, firstAction);
                            if (actionGroup.suspended) {
                                current.updateState = false;
                                continue;
                            }
                        }
                    }
                    if (current.updateState) {
                        if (Scene.manageLifecycle(current, constants.SCENE_NEXT_STATE)) {
                            deletedScenes.push(current);
                        }
                    } else {
                        nextRun = Defaults.SPRITE_RATE; // next frame
                    }
                }
            }
            SlowGlass.nextGroupsRun = millis + nextRun;
        }
        // delete any scenes that have finished 
        for (let j = 0; j < deletedScenes.length; j++) {
            for ( let k = 0; k < Globals.scenes.length; k++) {
                if (Globals.scenes[k] === deletedScenes[j]) {
                    const scene = Globals.scenes[k];
                    for (let i = 0; i < scene.sprites.length; i++) {
                        if (scene.sprites[i]) {
                            scene.sprites[i].piSprite.destroy();
                        }
                    }
                    Globals.scenes.splice(k,1);
                }
            }
        }

        // But sprites can be updated up to every frame if we want...
        if (SlowGlass.nextSpriteUpdate < millis) {
            Globals.frameNo += 1;
            for ( let i = 0; i < Globals.scenes.length; i++ ) {
                let current = Globals.scenes[i];
                if (current.state != constants.SCENE_RUNNING) {
                    continue;
                }
                // Found an active scene, now go through each sprite
                for ( let j = 0; j < current.sprites.length; j++ ) {
                    current.sprites[j].update(current.name, millis);
                }
            }
            SlowGlass.nextSpriteUpdate = millis + Defaults.SPRITE_RATE;
        }
    }

/**************************************************************************************************

   ######## ##    ## ######## ########  ##    ##    ########   #######  #### ##    ## ########  ######  
   ##       ###   ##    ##    ##     ##  ##  ##     ##     ## ##     ##  ##  ###   ##    ##    ##    ## 
   ##       ####  ##    ##    ##     ##   ####      ##     ## ##     ##  ##  ####  ##    ##    ##       
   ######   ## ## ##    ##    ########     ##       ########  ##     ##  ##  ## ## ##    ##     ######  
   ##       ##  ####    ##    ##   ##      ##       ##        ##     ##  ##  ##  ####    ##          ## 
   ##       ##   ###    ##    ##    ##     ##       ##        ##     ##  ##  ##   ###    ##    ##    ## 
   ######## ##    ##    ##    ##     ##    ##       ##         #######  #### ##    ##    ##     ######  

**************************************************************************************************/

    async scriptFromURL(url, include = false) {
        if (include) {
            Globals.log.report("Including script from " + url);
        } else {
            Globals.log.report("Starting Slow Glass from " + url);
            this.cleanUp();
        }
        const response = await fetch(url);
        if (!response.ok) {
            Globals.log.error(`Failed to fetch file: ${response.status} ${response.statusText}`);
        } else {
            const text = await response.text();
            if (this.readFromText(text, include, url.slice(0,url.lastIndexOf('/')))) {
                if (!include) {
                    this.run();
                } // include file just adds scenes to the existing list
            }
        }
    }

    interactiveAction(text) {
        const topScene = Scene.find(constants.MAIN_NAME);
        const interactiveGroup = topScene.actionGroups[topScene.interactive_index];
        interactiveGroup.actions = [];
        const lines = text.split(";");
        Globals.log.clearDuplicates();

        for (let i = 0; i < lines.length; i++) {
            const lineText = lines[i].trim();
            if (lineText.length < 1) {
                continue;
            }
            interactiveGroup.actions.push(new Utils.Line(i + 1, lineText));
        }
        interactiveGroup.nextAction = 0;
        do {
            topScene.runAction(interactiveGroup.nextAction, interactiveGroup, Date.now());
        } while (interactiveGroup.nextAction < interactiveGroup.actions.length);
    }

    setDrawingParent(elementID) {
        SlowGlass.sg_id = elementID;
    }

    setMessageParent(elementID) {
        Globals.log.messageParent(elementID);
    }

    onCompletion(callback) {
        Globals.completionCallback = callback;
    }

    setOption(optionName, optionValue) {
        switch(optionName.toLowerCase()) {
            case "latitude":
            case "lat":
                Globals.location.setLat(optionValue);
                break;
            case "longitude":
            case "long":
            case "lon":
                Globals.location.setLon(optionValue);
                break;
            case "evaluator":
                Globals.evaluator = optionValue;
                break;
            case "city":
                Globals.location.setCity(optionValue);
                break;
            case "cors":
            case "corsproxy":
                Globals.corsProxy = optionValue;
                break;
        }
    }

    cleanUp() {
        if (this.clean) { return; }
        // tidy up previous run
        AudioManager.deleteAll();
        if (Globals.app != null && Globals.app.stage.children.length > 0) {
            Globals.app.destroy(
                { removeView: true },    // removes the canvas element from the DOM
                {
                    children: true,        // destroy all children in the stage
                    texture: true,         // destroy textures used by children
                    textureSource: true,   // destroy the underlying GPU texture sources
                },
            );
        }
        this.clean = true;
        Globals.reset();
        Globals.app = new PIXI.Application();
    }

    scriptFromText(text) {
        Globals.log.report("Starting Slow Glass from textarea");
        // tidy up previous run
        this.cleanUp();
        if (this.readFromText(text)) {
            this.run();
        }
    }
}

window.slowGlass = new SlowGlass();
